import type { JSX } from 'react/jsx-runtime';

import * as React from 'react';

export const HomeIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    fill="none"
    viewBox="0 0 14 14"
    {...props}
  >
    <path
      stroke="#1A202B"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.336"
      d="m1.4 7 1.245-1.244m0 0L7 1.4l4.356 4.356m-8.711 0v6.222c0 .344.278.622.622.622h1.867m6.222-6.844L12.6 7m-1.244-1.244v6.222a.62.62 0 0 1-.622.622H8.867m-3.733 0a.62.62 0 0 0 .622-.622V9.489c0-.344.279-.622.622-.622h1.245c.343 0 .622.278.622.622v2.489c0 .344.278.622.622.622m-3.733 0h3.733"
    />
  </svg>
);
